<template>
    <div class="login-wrap">
        用户名：<input v-model="name">
        密码：<input v-model="password" type='password'>
        <div class="z-btn" @click="login">登录</div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                name:"1527319350@qq.com",
                password:"abcdefg",
            }
        },
    created(){
        
    },
        methods:{
            login(){
                let url = `${this.$url.pn}/get/token/login`;
                this.$axios.post(url,"",{
                    params:{
                        account:this.name,
                        password:this.password
                    }
                })
                .then(({data:res})=>{
                    if(res.code == 200){
                        sessionStorage.setItem('token',res.res_data)
                        this.$router.push({name:'dashboard'})
                    }
                })

            },
        }
    }
</script>

<style lang="less" scoped>
    .login-wrap{
        padding: 20px 30px;
        input{
            margin-right: 20px;
        }
    }
</style>
